import properties from "../features/Properties/store/propertiesSlice";
import packages from "../features/Packages/store/packagesSlice";
import auth from "../features/Auth/store/authSlice";

const reducers = {
  properties,
  packages,
  auth,
};

export default reducers;
